<template>
    <div class="flex flex-col justify-between h-full">
        <div>
            <p class="mb-3">{{ _label('question') }} <span v-text="question.no"></span>/<span v-text="count"></span></p>
            <h2 class="text-xl font-bold" v-text="_label(question.title)"></h2>
        </div>
        <div class="h-full my-3">
            <div v-if="question.type === 'options'" class="flex items-center mr-4 mb-2 text-lg" v-for="option, i in question.options">
                <input v-model="answer" :id="'hmsurvey-radio-' + question.no + '-' + i" type="radio" :value="option" class="hidden" />
                <label :for="'hmsurvey-radio-' + question.no + '-' + i" class="flex items-center cursor-pointer">
                    <span class="w-4 h-4 inline-block mr-2 rounded-full border border-gray-900 flex-shrink-0"></span>
                    {{ _label(option) }}
                </label>
            </div>
            <div v-if="question.type === 'open'" class="flex items-center mr-4 mb-2 h-full">
                <textarea v-model="answer" :placeholder="_label('describe_here')" type="text" class="outline-none border border-ultramarine h-full p-1"></textarea>
            </div>
        </div>
        <div class="text-center">
            <button :disabled="!answer" v-if="last" class="btn bg-ultramarine text-white btn rounded-full text-lg px-8 py-1 font-semibold" @click="submit" v-text="_label('finish')"></button>
            <button :disabled="!answer" v-else class="btn border border-ultramarine btn rounded-full text-lg px-8 py-1 font-semibold" @click="next" v-text="_label('next')"></button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['question', 'count', 'last', 'value'],
        name: "HMSurveyQuestion",
        data() {
            return {
                answer: null,
            };
        },
        methods: {
            next() {
                if (!this.answer) {
                    return;
                }
                this.$emit('next');
            },
            submit() {
                this.$emit('submit');
            },
            _label(key) {
                return this.$options.filters['lang']('copy.' + key);
            }
        },
        watch: {
            question() {
                this.answer = this.value;
            },
            answer(val) {
                this.$emit('input', val);
            }
        }
    }
</script>

<style scoped>

</style>